import {sanitizeHtml} from "./utitlities";

export default {
    paragraph: function (data, config) {
        return `<p class="${config.paragraph.pClass}"> ${data.text} </p>`;
    },

    header: function (data) {
        return `<h${data.level}>${data.text}</h${data.level}>`;
    },

    list: function (data) {
        const type = data.style === "ordered" ? "ol" : "ul";
        const items = data.items.reduce((acc, item) => acc + `<li>${item}</li>`, "");
        return `<${type}>${items}</${type}>`;
    },

    quote: function (data, config) {
        let alignment = "";
        if (config.quote.applyAlignment) {
            alignment = `style="text-align: ${data.alignment};"`;
        }
        return `<blockquote ${alignment}><p>${data.text}</p><cite>${data.caption}</cite></blockquote>`;
    },

    table: function (data) {
        const rows = data.content.map((row) => {
            return `<tr>${row.reduce((acc, cell) => acc + `<td>${cell}</td>`, "")}</tr>`;
        });
        return `<table><tbody>${rows.join("")}</tbody></table>`;
    }, image: function (data, config) {
        const imageConditions = `${data.stretched ? "img-fullwidth" : ""} ${data.withBorder ? "img-border" : ""} ${data.withBackground ? "img-bg" : ""}`;
        const imgClass = config.image.imgClass || "";
        let imageSrc;

        if (data.url) {
            // simple-image was used and the image probably is not uploaded to this server
            // therefore, we use the absolute path provided in data.url
            // so, config.image.path property is useless in this case!
            imageSrc = data.url;
        } else if (config.image.path === "absolute") {
            imageSrc = data.file.url;
        } else {
            imageSrc = config.image.path.replace(/<(.+)>/, (match, p1) => data.file[p1]);
        }

        if (config.image.use === "img") {
            return `<img class="${imageConditions} ${imgClass}" src="${imageSrc}" alt="${data.caption}">`;
        } else if (config.image.use === "figure") {
            const figureClass = config.image.figureClass || "";
            const figCapClass = config.image.figCapClass || "";

            return `<figure class="${figureClass}"><img class="${imgClass} ${imageConditions}" src="${imageSrc}" alt="${data.caption}"><figcaption class="${figCapClass}">${data.caption}</figcaption></figure>`;
        }
    }, code: function (data, config) {
        const markup = sanitizeHtml(data.code);
        return `<pre><code class="${config.code.codeBlockClass}">${markup}</code></pre>`;
    }, raw: function (data) {
        return data.html;
    }, delimiter: function () {
        return "<div class='ce-delimiter' ></div>";
    }, warning: function (data) {
        return `<div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                  <div class="flex">
                    <div class="flex-shrink-0">
                      <!-- Heroicon name: solid/exclamation -->
                      <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                      </svg>
                    </div>
                    <div class="ml-3">
                      <span class="text-sm text-yellow-700">${data.message}</span>
                    </div>
                  </div>
                </div>`;
    },

    embed: function (data, config) {
        if (config.embed.useProvidedLength) {
            data.length = `width="${data.width}" height="${data.height}"`;
        } else {
            data.length = "";
        }
        const regex = new RegExp(/<%data\.(.+?)%>/, "gm");
        if (config.embedMarkups[data.service]) {
            return config.embedMarkups[data.service].replace(regex, (match, p1) => data[p1]);
        } else {
            return config.embedMarkups["defaultMarkup"].replace(regex, (match, p1) => data[p1]);
        }
    },
};